module.exports = __webpack_public_path__ + "static/img/tub_cfe_logo.c55381fb.svg";